import axios from 'axios';
import endpoints from '../define/endpoints';

export async function storeReview(
  data,
  bearerToken = null,
  reviewToken = null
) {
  const requestData = {
    id: data.id,
    id_order: data.orderId,
    id_user: data.userId,
    title: data.title,
    score: data.score,
    description: data.description,
    status: data.status,
    shared_with: data.shared_with,
  };

  const url = `${endpoints.core}/reviews`;
  const authorizationHeader = bearerToken
    ? { Authorization: `Bearer ${bearerToken}` }
    : { 'Action-Token-Authorization': reviewToken };

  try {
    const response = await axios({
      method: 'post',
      headers: authorizationHeader,
      url: url,
      data: requestData,
    });

    return response.data;
  } catch (err) {
    return null;
  }
}

export async function getReview(
  orderId,
  bearerToken = null,
  reviewToken = null
) {
  const url = `${endpoints.core}/orders/${orderId}/review`;

  const authorizationHeader = bearerToken
    ? { Authorization: `Bearer ${bearerToken}` }
    : { 'Action-Token-Authorization': reviewToken };

  try {
    const response = await axios({
      method: 'get',
      url: url,
      headers: {
        ...authorizationHeader,
      },
    });

    return response.data;
  } catch (err) {
    return null;
  }
}
